//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { TariffRentalDetailsDTO } from 'src/app/core/models/system/tariff/tariff-rental-details.dto';

@Injectable({ providedIn: 'root' })

export class TariffsRentalDetailsService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public getById(id: number): Observable<TariffRentalDetailsDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.TariffsRentalDetails +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public post(rentalTariffDetails: TariffRentalDetailsDTO): Observable<TariffRentalDetailsDTO> {
    try {
      //JSON.stringify(rentalTariffDetails)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(rentalTariffDetails))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.TariffsRentalDetails +
                                                               "?objectEnc=" + objectEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
  public put(rentalTariffDetails: TariffRentalDetailsDTO): Observable<TariffRentalDetailsDTO> {
    try {
      //JSON.stringify(rentalTariffDetails)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(rentalTariffDetails))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.TariffsRentalDetails +
                                                              "?id=" + rentalTariffDetails.id +
                                                              "&objectEnc=" + objectEnc, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
        
  public save(rentalTariffDetails: TariffRentalDetailsDTO): Observable<any> {
    try {
      //JSON.stringify(rentalTariffDetails);

      if (rentalTariffDetails.id && <number>rentalTariffDetails.id>0)
        return this.put(rentalTariffDetails);
      
      return this.post(rentalTariffDetails);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
